var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cardData.header)?_c('div',{staticClass:"frmod-cl card-shadow",class:[
    {'frmod-cl-selected' : _vm.selected},
    {'frmod-cl-designer': _vm.designer } ]},[_c('div',{staticClass:"frmod-cl-h",on:{"click":_vm.handleClick}},[_c('label',[_vm._v(_vm._s(_vm.cardData.header[_vm.$root.locale.key]))])]),_c('div',{staticClass:"frmod-clc"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }